import { SaleConfirmationSentryOpts } from '../DocumentCapture.helpers';

export const captureSentryException = (err: unknown, options = SaleConfirmationSentryOpts) => {
  window?.Sentry?.captureException?.(err, options);
};
